import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  text: 'La cocina estaba vieja y la veníamos pateando hace años porque no queríamos meternos en una obra. En un fin de semana la cambiamos nosotros y quedó realmente moderna, nada que ver a lo que era.',
  author: 'Carolina M. Administrativa · Buenos Aires'
}, {
  text: 'Vivo en alquiler y siempre pensé que no podía tocar nada. Hice todo reversible y cuando vinieron mis amigas me preguntaron si me había mudado. No podían creer que no rompí nada.',
  author: 'Valeria S. Emprendedora · Córdoba'
}, {
  text: 'Pedí presupuesto para el baño y era una locura. Probé esto medio desconfiado y la verdad es que el cambio se nota un montón. No parece improvisado, quedó prolijo de verdad.',
  author: 'Marcos L. Empleado Bancario · Rosario'
}, {
  text: 'Lo que más me sorprendió fue lo fácil que fue modernizar los muebles sin lijar ni pintar. En un día cambió todo el ambiente y ahora sí me gusta cómo se ve mi casa.',
  author: 'Andrea G. Docente · La Plata'
}, {
  text: 'Siempre dije que no me iba a meter en obras porque es un quilombo. Actualicé la cocina y el piso sin romper nada y el resultado quedó mucho mejor de lo que esperaba.',
  author: 'Diego R. Comerciante · Mendoza'
}];
export function TestimonialGrid() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-lightgray" data-id="element-189">
      <div className="max-w-5xl mx-auto" data-id="element-190">
        <div className="text-center mb-5" data-id="element-191">
          <h2 className="text-xl md:text-2xl font-black text-black tracking-tight" data-id="element-192">
            Escuchá lo que dicen quienes ya lo aplicaron
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-193">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-white p-4 rounded-xl shadow-sm border border-black/5 flex flex-col" data-id="element-194">
              <div className="text-orange tracking-widest mb-2 text-base" data-id="element-195">
                ★★★★★
              </div>

              <p className="text-black/90 font-medium italic mb-3 text-xs leading-relaxed flex-grow" data-id="element-196">
                "{testimonial.text}"
              </p>

              <div className="border-t border-black/5 pt-2 mt-auto" data-id="element-197">
                <p className="font-bold text-black text-[10px] uppercase tracking-wide" data-id="element-198">
                  {testimonial.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}